import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { WalletProvider } from "./components/fetch/WalletContext";

ReactDOM.render(
  <WalletProvider>
    <App />
  </WalletProvider>,
  document.getElementById("root")
);

reportWebVitals();
